import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { Subscription } from 'rxjs';
import { FormGroup, FormControl } from '@angular/forms';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { ReportsTurnsService } from 'src/app/services/turns-services/reports-turns-service/reports-turns.service';
import { Json2csvService } from 'csvtools-lib';
import { DateUnixTransformerPipe } from 'src/app/pipes/date-unix-transformer-pipe/date-unix-transformer.pipe';

@Component({
  selector: 'app-turns-reports-filter-reports-card',
  templateUrl: './turns-reports-filter-reports-card.component.html',
  styleUrls: ['./turns-reports-filter-reports-card.component.scss']
})
export class TurnsReportsFilterReportsCardComponent implements OnInit, OnDestroy {

  @Input() data;
  show: boolean;
  showAdvanced: boolean;
  centerList;
  desksList;
  availableStatusList;
  statusList;
  searchReportsSubscription: Subscription;
  refreshAssistancesList: Subscription;
  basicDataForm = new FormGroup({
    dateFrom: new FormControl(''),
    dateTo: new FormControl(''),
    selectedCentersList: new FormControl(),
    selectedDesksList: new FormControl()
  });
  constructor(private userStorageService: UserStorageService,
              private reportsService: ReportsTurnsService,
              private json2csvService: Json2csvService,
              private dateUnixTrannsformerPipe: DateUnixTransformerPipe,
              private snackbarService: SnackBarService) {
                this.show = false;
                this.availableStatusList = ['ACTIVE', 'INACTIVE', 'DELETED'];
                this.statusList = new Array();
  }

  ngOnInit() {
    this.centerList = this.userStorageService.getCenterList();
    console.log("dentro nginig")
    if (this.reportsService.getRememberedForm().form) {
      console.log("dentro if")
      this.basicDataForm = this.reportsService.getRememberedForm().form;
      this.statusList = this.reportsService.getRememberedForm().statusList;
      this.showAdvanced = this.reportsService.getRememberedForm().showAdvanced;
      this.search();
    }
  }

  public search() {
    this.show = false;
    const dateFrom = this.basicDataForm.get('dateFrom').value.valueOf();
    const dateTo = this.basicDataForm.get('dateTo').value.valueOf();
    this.reportsService.rememberForm(this.basicDataForm, this.statusList, this.showAdvanced);
    this.searchReportsSubscription = this.reportsService.filterTurnsList(this.basicDataForm.get('dateFrom').value.valueOf(), this.basicDataForm.get('dateTo').value.valueOf(), this.mapCentersIds(this.basicDataForm.get('selectedCentersList').value), this.statusList, []).subscribe(
      (res) => {
        if (res['data']) {
          this.reportsService.refreshReportsList(res);
        }
      },
      (error) => {
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  public clearField(fieldName) {
    this.basicDataForm.patchValue({
      [fieldName]: null
    });
  }

  public centersOutputEventReceiver(centers) {
    const aux = new Array();
    for (const c of centers) {
      aux.push(c[1]._data);
    }
    this.basicDataForm.get('selectedCentersList').setValue(aux);
  }
  public mapCentersIds(centers) {
    if (centers && (centers.length > 0)) {
      return centers.map((center) => center.InternalId);
    } else {
      return [];
    }
  }

  public getDesksList(centers) {}

  public desksOutputEventReceiver(desksList) {
    const aux = new Array();
    for (const s of desksList) {
      aux.push(s[1]._data);
    }
    this.basicDataForm.get('selectedDesksList').setValue(aux);
  }

  public mapDesksIds(desksList) {
    if (desksList && (desksList.length > 0)) {
      return desksList.map((desk) => desk.internalId);
    }
  }

  public setPreselected(op1, op2) {
    if (op1 && op2) {
      return op1.InternalId === op2.InternalId;
    }
  }

  public addStatus(status) {
    if ( !this.statusList.find(
      (s) => {
        return s === status.value; } )) {
          this.statusList.push(status.value);
    }
  }

  public deleteStatus(status) {
    this.statusList = this.statusList.filter(
      (s) => {
        return s !== status;
      }
    );
  }

  public showFilter() {
    this.show = !this.show;
  }

  public showAdvancedFilter() {
    this.showAdvanced = !this.showAdvanced;
  }

  public generateCSV() {
    this.data.forEach(i => i['turnsDate'] = this.dateUnixTrannsformerPipe.transform(i['turnsDate'], 'false'));
    this.json2csvService.setBody(this.data, ['turnDeskStatus', 'turnDeskName', 'centerName', 'smsTurnsPicked', 'ticketTurnsPicked', 'totalTurnsAttended', 'totalTurnsCancelled', 'totalTurnsPassed', 'turnsWaitAverageSecs', 'appTurnsPicked', 'turnsDate']);
    this.json2csvService.setHeader(['Status', 'Attention', 'Center', 'SMS', 'Ticket', 'Attended', 'Cancelled', 'Passed', 'Average', 'APP picked', 'Date']);
    this.json2csvService.generateCSV('turns-reports');
  }

  public generateTurnsCSV() {
    // this.reportsService.rememberForm(this.basicDataForm, this.statusList, this.showAdvanced);

    this.searchReportsSubscription = this.reportsService.turnsDetailsList(
      this.basicDataForm.get('dateFrom').value.valueOf(),
      this.basicDataForm.get('dateTo').value.valueOf(),
      this.mapCentersIds(this.basicDataForm.get('selectedCentersList').value)
    ).subscribe(
      (res) => {
        if (res) {
          const turnsDetails = res;
          turnsDetails.forEach(i => {
            i['creationDateTimezone'] = this.dateUnixTrannsformerPipe.transform(i['creationDateTimezone'])
            i['attendingDateTimezone'] = this.dateUnixTrannsformerPipe.transform(i['attendingDateTimezone'])
            i['endDateTimezone'] = this.dateUnixTrannsformerPipe.transform(i['endDateTimezone'])
          });
          this.json2csvService.setBody(turnsDetails, ['centerName', 'deskName', 'nbTurn', 'valueString', 'location', 'status', 'secondsInWaiting', 'secondsInAttending', 'creationDateTimezone', 'attendingDateTimezone', 'endDateTimezone']);
          this.json2csvService.setHeader(['Center', 'Desk', 'Turn', 'Value', 'Location', 'Status', 'Seconds waiting', 'Seconds attending', 'Creation date', 'Attending date', 'End attending date']);
          this.json2csvService.generateCSV('turns-details-report');
        }
      },
      (error) => {
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  ngOnDestroy() {
    if (this.searchReportsSubscription) { this.searchReportsSubscription.unsubscribe(); }
  }

  isGenerateTurnsEnabled() {
    return this.basicDataForm.get('dateFrom').value && this.basicDataForm.get('dateTo').value;
  }
}
